import { UseQueryResult } from '@tanstack/react-query';
import { warehouseApi } from 'src/api/warehouse';
import { WarehouseActivationDto } from 'woofwoof-api';
import { warehouseRequestOptions } from '../utils/request';
import { useWarehouseQuery } from './useWarehouseQuery';

/** Magazyn is visible when enabled, or when disabled but the organization has history. */
export function isWarehouseVisible(
  activation?: WarehouseActivationDto,
): boolean {
  return Boolean(activation && (activation.enabled || activation.hasHistory));
}

/** Stock-changing actions (approve, KOR, batch assignment) need an enabled warehouse. */
export function canWriteStock(activation?: WarehouseActivationDto): boolean {
  return activation?.enabled === true;
}

export type WarehouseShellState = 'loading' | 'error' | 'hidden' | 'visible';

/**
 * What the Magazyn page may show. It fails closed like the nav entry: no tabs
 * until the activation answer arrives, and none when it cannot be read.
 */
export function warehouseShellState(
  activation: Pick<
    UseQueryResult<WarehouseActivationDto>,
    'isSuccess' | 'isError' | 'data'
  >,
): WarehouseShellState {
  if (activation.isSuccess) {
    return isWarehouseVisible(activation.data) ? 'visible' : 'hidden';
  }
  return activation.isError ? 'error' : 'loading';
}

/** Key `['warehouse-activation', organizationId]` (review S3, decision R1). */
export function useWarehouseActivation(): UseQueryResult<WarehouseActivationDto> {
  return useWarehouseQuery(
    'warehouse-activation',
    [],
    async (organizationId, signal) =>
      (
        await warehouseApi.warehouseActivationControllerGetActivation(
          {},
          warehouseRequestOptions(organizationId, signal),
        )
      ).data,
  );
}
